import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO helmet. Defaults target Gens Realty Houston brand.
 */
export default function Seo({
  title,
  description,
  image,
  path = "",
  type = "website",
  noindex = false,
}) {
  const siteName = "Gens Realty, LLC";
  const base =
    typeof window !== "undefined" ? window.location.origin : "";
  const url = `${base}${path}`;
  const fullTitle = title ? `${title} · ${siteName}` : `${siteName} — Houston Real Estate`;
  const desc =
    description ||
    "Boutique residential real estate brokerage in Houston, Texas. Buy, sell, and explore Houston's most sought-after neighborhoods with Gens Realty.";
  const img =
    image ||
    "https://images.unsplash.com/photo-1749215695604-4d98a9338dec?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={img} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
